import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ViewChild, ElementRef, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MapService, ScaleBarToolConfigModel, ScaleBarToolModel, ToolTypeEnum } from '@tailormap-viewer/map';
import { BaseComponentTypeEnum } from '@tailormap-viewer/api';

@Component({
    selector: 'tm-scale-bar',
    templateUrl: './scale-bar.component.html',
    styleUrls: ['./scale-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaleBarComponent implements OnInit, OnDestroy {
  private mapService = inject(MapService);


  public scaleType: 'bar' | 'line' = 'bar';

  @ViewChild('scaleTarget', { static: true, read: ElementRef })
  public scaleTarget: ElementRef | undefined;

  private destroyed = new Subject();

  public ngOnInit(): void {
    this.mapService.createTool$<ScaleBarToolModel, ScaleBarToolConfigModel>({
      type: ToolTypeEnum.ScaleBar,
      scaleType: this.scaleType,
      alwaysEnabled: true,
      owner: BaseComponentTypeEnum.SCALE_BAR,
    })
      .pipe(takeUntil(this.destroyed))
      .subscribe(({ tool }) => {
        if (this.scaleTarget) {
          tool.setTarget(this.scaleTarget.nativeElement);
        }
      });
  }

  public ngOnDestroy() {
    this.destroyed.next(null);
    this.destroyed.complete();
  }


}
